import React from 'react';
import { useDispatch } from 'react-redux';
import { dispatcher } from 'dispatcher';

import { ReCaptchaWithTitle } from '@interlayer/js/app/components/main/ReCaptchaWithTitle';

import { DELAY_FOR_RECAPTCHA_REQUEST } from '@interlayer/js/app/components/main/ReCaptchaWithTitle/constants';
import { ON_BLUR_EMAIL_FIELD } from '@interlayer/js/app/components/main/Registration/constants';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { setIsShowReCaptcha } from '@interlayer/js/app/store/reducers/Registration/actions';

import style from './ReCaptchaCheckUserName.scss';

export const ReCaptchaCheckUserName: React.FC = () => {
    const dispatch = useDispatch();
    const { isShowReCaptcha } = useRegistrationSelector();

    if (!isShowReCaptcha) {
        return null;
    }

    const handlerOnValidate = (response?: { token: string }) => {
        dispatcher.dispatch(ON_BLUR_EMAIL_FIELD, response?.token);

        setTimeout(() => {
            dispatch(setIsShowReCaptcha(false));
        }, DELAY_FOR_RECAPTCHA_REQUEST);
    };

    return (
        <ReCaptchaWithTitle
            titleTKey="checkUsernameAvailability"
            operation="checkUsernameAvailability"
            onValidate={handlerOnValidate}
            classNames={{ wrapper: style.container }}
        />
    );
};
